MILE:
    en: mi
    es: mi.
    fr: mi.
    pt: milhas
    ru: миль
METER:
    en: m
    es: mtr.
    fr: m
    pt: m
    ru: м
FOOT:
    en: ft
    es: pie
    fr: ft
    pt: ft
LITER_PER_100_KILOMETER:
    en: 'l / 100 km'
    es: 'l / 100 km'
    fr: 'l / 100 km'
    pt: 'l / 100 km'
    ru: 'л / 100 км'
LITER_PER_100_MILE:
    en: 'l / 100 mi.'
    es: 'l / 100 mi.'
    fr: 'l / 100 mi.'
    pt: 'l / 100 mi.'
    ru: 'л / 100 миль'
MILLIMETER:
    en: mm
    es: mm
    fr: mm
    pt: mm
INCH:
    en: in
    es: pulg.
    fr: in
    pt: In
h:
    en: h
    es: h
    fr: h
    pt: h
    ru: ч.
YARD:
    en: yd
    es: yd.
    fr: yd
    pt: yd
m:
    en: m
    es: m
    fr: m
    pt: m
    ru: мин
GRAM:
    en: gram
    es: gr.
    fr: gramme
    pt: gr
    ru: грамм
DECIMETRE:
    en: dm
    es: dm
    fr: dm
    pt: dm
POUND_UK:
    en: pounds
    es: Libras
    fr: livre(UK)
    pt: pounds
CENTIMETER:
    en: cm
    es: cm
    fr: cm
    ru: см
    pt: cm
KILOMETRE:
    en: km
    es: km.
    fr: km
    pt: km
    ru: км
TONNE:
    en: tonne
    es: tonelada
    fr: tonne
    pt: toneladas
KILOGRAM:
    en: kg
    es: Kg
    fr: kg
    pt: kg
    ru: кг
TON_UK:
    en: ton(UK)
    es: ton(UK)
    fr: ton(UK)
    pt: 'ton (UK)'
TON_US:
    en: ton(US)
    es: ton(US)
    fr: ton(US)
    pt: 'ton (US)'
NAUTICAL_MILE:
    en: n.m.
    es: 'mill. naut.'
    fr: n.m.
    pt: n.m.
seconds:
    en: seconds
    es: segundos
    fr: secondes
    pt: segundos
    ru: секунд
minutes:
    en: minutes
    es: minutos
    fr: minutes
    pt: minutos
    ru: минут
MILES_PER_HOUR:
    en: mph
    es: mi/h
    fr: mi/h
    pt: mph
    ru: миль/ч
KILOMETERS_PER_HOUR:
    en: km/h
    es: km/h
    fr: km/h
    pt: km/h
    ru: км/ч
hours:
    en: hours
    es: horas
    fr: heures
    pt: horas
    ru: часов
days:
    en: days
    es: días
    fr: jours
    pt: dias
    ru: дней
weeks:
    en: weeks
    es: semanas
    fr: semaines
    pt: semanas
    ru: недель
for_MILE:
    en: mile
    es: milla
    fr: mile
    pt: milha
    ru: милю
for_KILOMETRE:
    en: km
    es: km
    fr: kilomètre
    pt: km
    ru: километр
day:
    en: day
    ru: день
    es: día
    pt: dia
    fr: jour
day_dual:
    en: days
    ru: дня
    es: días
    pt: dias
    fr: jours
day_plural:
    en: days
    ru: дней
    es: días
    pt: dias
    fr: jours
minute:
    en: minute
    ru: минута
    es: ''
    pt: minuto
minute_dual:
    en: minutes
    ru: минуты
    es: ''
    pt: minutos
minute_plural:
    en: minutes
    ru: минут
    es: ''
    pt: minutos
